export default {
    rating: {
        please_rate: 'Please rate service (1-5)',
        google_rate: 'Would you like to share your experience on our Google Business profile as well?',
        comment: {
            label: 'Comment',
            placeholder: 'Enter comment',
        },
    },
}
